import React, { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { countryTransfertService } from "../../../../services/administration/countryTransfertService";
import { downloadDailyRatesPdf } from "../../../../utils/downloadDailyRatesPdf";
import { alertError } from "../../../../helpers/alertError";

/**
 * Bouton "Télécharger le PDF des taux".
 * Au clic : récupère les taux à jour et télécharge le tableau quotidien (format du modèle Excel).
 */
const DownloadRatesPdfButton: React.FC<{ className?: string }> = ({ className = "" }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const rates = await countryTransfertService.getCountryTransferts(500, 0);
      await downloadDailyRatesPdf(rates || []);
    } catch (error) {
      console.error(error);
      alertError("Impossible de générer le PDF des taux.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      disabled={loading}
      className={`bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2 disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      <span>{loading ? "Génération..." : "Télécharger le PDF des taux"}</span>
    </button>
  );
};

export default DownloadRatesPdfButton;
